import { array, object, string } from 'yup'

export const validations = object().shape({
   emails: array()
      .of(string().min(1).email('Debe ingresar correos electrónicos válidos'))
      .min(1, 'El campo es obligatorio')
      .required('El campo es obligatorio')
})
